import React from 'react'
import '../styles/global.scss'
import { Link } from 'gatsby'
import { FaFacebook } from 'react-icons/fa'
import { FaInstagram } from 'react-icons/fa'

export default function Layout() {
  return <footer className="footer">
    <div className="footer-top">
        <div className="container">
            <div className="footer-info">
                <div className="footer-block">
                    <h2>Verve Kombucha</h2>
                    <p>Located in Cedar Valley, IA, we are the area's first kombucha brewery with room for private events. Our space is equipped with a full kitchen and bar with views of our kombucha brewing tanks and patio seating during the summer.</p>
                </div>
                <div className="footer-block">
                    <h2>Contact Us</h2>
                    <a href="mailto:vervekombucha@gmail.com">vervekombucha@gmail.com</a>
                    <a href="tel:(319) 232-6794">(319) 232-6794</a>
                </div>
            </div>
        </div>
    </div>
    <div className="footer-bottom">
        <div className="container">
            <ul className="social-icons">
                <li className="social-icon social-facebook">
                    <a href="https://www.facebook.com/vervekombucha/">
                        <FaFacebook />
                    </a>
                </li>
                <li className="social-icon social-instagram">
                    <a href="https://www.instagram.com/vervekombucha/">
                        <FaInstagram />
                    </a>
                </li>
            </ul>
            <p className="copyright">Copyright © 2019 Verve Kombucha. <span className="line-break"></span>All Rights Reserved.</p>
            <p><Link to="/terms-of-service">Terms</Link> | <Link to="/privacy-policy">Privacy</Link></p>
        </div>
    </div>
</footer>;
}
